import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Row } from 'components/Containers/Row/Row';
import SectionContainer from 'components/Containers/SectionContainer';
import Label from 'components/form/Label/Label';
import AppStoreIconGroup from 'components/icons/AppStoreIconGroup';
import { useSeenModulePixel } from 'hook/helper.hook';
import { CASH_DOWNLOAD } from 'types/morph.pagePosition.constants';
import { BANKING_VERTICAL } from 'types/mrph.vertical.constants';

export const DownloadAppModule = ({ handleAppDownloadClick }) => {
  const datatestid = 'downloadAppModule';
  const pixel = useSeenModulePixel({
    'Module Name': CASH_DOWNLOAD,
    Vertical: BANKING_VERTICAL,
  });

  return (
    <SectionContainer datatestid={datatestid}>
      {pixel}
      <Row datatestid={datatestid}>
        <FlexContainer
          rows
          justifyCenter
          alignItemsCenter
          className="m-flex-column"
        >
          <FlexContainer column className="format50 m-format100">
            <Label
              datatestid={`${datatestid}-title`}
              type="H3"
              typeHeader={'h3'}
            >
              Download the app
            </Label>
            <div className="padB16" />
            <Label datatestid={`${datatestid}-description`}>
              Get access to all of Sesame Cash’s features like cash back offers
              and bill pay.
            </Label>
          </FlexContainer>
          <FlexContainer
            column
            alignItemsStretch
            className="format50 m-format100 margT30"
          >
            <FlexContainer
              rows
              justifyEnd
              alignItemsCenter
              className="format100 m-justify-start"
            >
              <AppStoreIconGroup
                datatestid={datatestid}
                handleAppDownloadClick={handleAppDownloadClick}
                storesImagesClasses="download-app-module-icon"
              />
            </FlexContainer>
          </FlexContainer>
        </FlexContainer>
      </Row>
    </SectionContainer>
  );
};
